/**
 * @author: lv.chen
 * @date: 2025/10/10
 * @desc: 季报页面下载按钮组件
 */
import React from 'react';
import classnames from 'classnames';
// import { useIntl } from 'umi';
import { Button } from 'tea-component';

import './index.scss';

interface IDownloadButtonProps extends IBaseProps {
  disabled?: boolean;
  loading?: boolean;
  /**
   * 点击下载按钮的回调函数
   */
  onClick?: () => void;
}

/**
 * 下载按钮组件
 */
const DownloadButton: React.FC<IDownloadButtonProps> = (props) => {
  const { style, className, disabled = false, loading, onClick } = props;

  // const { formatMessage } = useIntl();

  return (
    <Button
      style={style}
      className={classnames('dbu-quarter-report-download-button', className)}
      type="icon"
      icon={loading ? 'loading' : 'download'}
      // title={formatMessage({ id: 'dbu_common_download' })}
      disabled={disabled || loading}
      onClick={(e) => {
        e?.stopPropagation();
        onClick?.();
      }}
    />
  );
};

export default DownloadButton;
